module.exports = __webpack_public_path__ + "img/zt_logo_sm1.90aaed3e.png";